var map = {
	"./__tests__/lti.resourceImported.test.js": [
		"LFe7",
		4136
	],
	"./__tests__/lti.screenReaderAlert.test.js": [
		"0Guc",
		4137
	],
	"./__tests__/requestFullWindowLaunch.test.js": [
		"o6ta",
		4138
	],
	"./lti.enableScrollEvents.js": [
		"HVU3",
		4198
	],
	"./lti.fetchWindowSize.js": [
		"OANa",
		4199
	],
	"./lti.frameResize.js": [
		"bSyB",
		4128
	],
	"./lti.removeUnloadMessage.js": [
		"tjuu",
		4139
	],
	"./lti.resourceImported.js": [
		"FC2N",
		4200
	],
	"./lti.screenReaderAlert.js": [
		"YYEg",
		4201
	],
	"./lti.scrollToTop.js": [
		"W/R1",
		4202
	],
	"./lti.setUnloadMessage.js": [
		"6fDN",
		4140
	],
	"./lti.showModuleNavigation.js": [
		"NSTA",
		4203
	],
	"./requestFullWindowLaunch.js": [
		"8IHO",
		4204
	],
	"./toggleCourseNavigationMenu.js": [
		"ECMy",
		3636,
		4205
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "G4i8";
module.exports = webpackAsyncContext;